import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@h2/ui';
import { Button } from '@h2/ui';
import { Textarea } from '@h2/ui';
import { useConfigurationStore } from '../../stores/useConfigurationStore';

export const ConfigurationManifest: React.FC = () => {
  const {
    jsonText,
    jsonError,
    updateJsonText,
    formatJson
  } = useConfigurationStore();

  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-start">
          <div>
            <CardTitle>JSON 매니페스트 편집</CardTitle>
            <CardDescription>
              설정 데이터를 JSON 형식으로 직접 편집할 수 있습니다. 유효한 JSON을 입력하면 다른 모드에서 자동으로 반영됩니다.
            </CardDescription>
          </div>
          
          <div className="flex gap-2">
            <Button
              variant="outline"
              onClick={formatJson}
              disabled={!!jsonError}
            >
              포맷팅
            </Button>
            
            {jsonError && (
              <div className="text-xs text-orange-600 bg-orange-50 px-2 py-1 rounded flex items-center">
                ⚠️ 변경사항이 적용되지 않음
              </div>
            )}
            
            {!jsonError && jsonText && (
              <div className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded flex items-center">
                ✅ 유효한 JSON
              </div>
            )}
          </div>
        </div>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-4">
          <Textarea
            value={jsonText}
            onChange={(e) => updateJsonText(e.target.value)}
            className={`font-mono text-sm min-h-[400px] ${
              jsonError ? 'border-red-500' : ''
            }`}
            placeholder="JSON 데이터를 입력하세요..."
          />
          
          {jsonError && (
            <div className="text-sm text-red-500 bg-red-50 p-3 rounded-md">
              {jsonError}
            </div>
          )}
          
          <div className="text-xs text-gray-500 bg-gray-50 p-3 rounded-md">
            <div className="grid grid-cols-2 gap-4">
              <div>줄 수: {jsonText.split('\n').length}</div>
              <div>문자 수: {jsonText.length}</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
